<template>
  <div>
    <plan-benefit-dialog
      :model="planBenefitDialog"
      @close="planBenefitDialog = false"
      :effectiveDate="effectiveDate"
      :planIdentityId="planIdentityId"
      :id="selectedPlanBenefitId"
      :benefitName="selectedPlanBenefitName"
      :memberGroupIdentityId="memberGroupIdentityId"
    />
    <v-container fluid grid-list-md v-if="loading">
      <v-layout row justify-center>
        <v-flex xs12 sm6 md4 lg3>
          <v-progress-circular indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-container>
    <v-row
      style="cursor:pointer"
      class="mt-2 mb-0"
      no-gutters
      v-for="planBenefit in planBenefits"
      :key="planBenefit.Benefit.Id"
      @click="
        selectedPlanBenefit = planBenefit;
        planBenefitDialog = true;
      "
    >
      <v-col class="ml-2 mb-2">
        <v-icon class="mr-3">
          visibility
        </v-icon>
        {{ translate2(planBenefit.Benefit, "Name") }}
      </v-col>
    </v-row>
    <error-handler :error="error" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { translate2 } from "@/trans2";
import PlanBenefitDialog from "./PlanBenefitDialog.vue";
import ErrorHandler from "../ErrorHandler.vue";
export default {
  props: ["effectiveDate", "planIdentityId", "category", "memberGroupIdentityId"],
  components: {
    PlanBenefitDialog,
    ErrorHandler,
  },
  data() {
    return {
      planBenefits: [],
      planBenefitDialog: false,
      selectedPlanBenefit: null,
      loading: false,
      error: null,
    };
  },
  computed: {
    selectedPlanBenefitId() {
      if (this.selectedPlanBenefit) {
        return this.selectedPlanBenefit.Benefit.Id;
      }
      return null;
    },
    selectedPlanBenefitName() {
      if (this.selectedPlanBenefit) {
        return translate2(this.selectedPlanBenefit.Benefit, "Name");
      }
      return null;
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions("claims", ["getPlanBenefitsByEffectiveDateAndCategory"]),
    translate2(item, field) {
      return translate2(item, field);
    },
    async loadData() {
      this.loading = true;
      try {
        this.planBenefits = (await this.getPlanBenefitsByEffectiveDateAndCategory({
          memberGroupIdentityId: this.memberGroupIdentityId,
          effectiveDate: this.effectiveDate,
          category: this.category
        })).data.value;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
